/* Laser GCC homepage sections: one script shared by every lgcc-* homepage section.
   Each section root is <div class="lgcc-h" data-lgcc="<feature>">; features start on page load
   and again when a section is added or edited in the theme editor. */
(function(){
  if (window.LGCC_HOME) return;
  const ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const plus = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  const check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const esc = v => String(v == null ? "" : v).replace(/[&<>"]/g, c => ({"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;"}[c]));
  const $ = (s, el) => el.querySelector(s);
  const $$ = (s, el) => [...el.querySelectorAll(s)];
  const data = root => { try { return JSON.parse($("script[data-lgcc-products]", root).textContent); } catch (e) { return []; } };

  /* ---------- product cards ---------- */
  const BRANDS = ["Candela", "Cynosure", "Quanta System", "Quanta", "DEKA", "Lumenis", "Lutronic", "Zimmer", "Vydence"];
  function brandOf(title){
    const t = title.toLowerCase(); let best = "", at = Infinity;
    BRANDS.forEach(b => { const k = t.indexOf(b.toLowerCase()); if (k > -1 && k < at) { at = k; best = b; } });
    return best === "Quanta" ? "Quanta System" : best;
  }
  const isUsa = x => /made in usa/i.test(x.t) || (x.tags || []).some(t => /made.?in.?usa/i.test(t));
  const off = x => x.c > x.p ? Math.round((1 - x.p / x.c) * 100) : 0;
  const price = x => `${x.from ? '<span class="lg-from">From</span>' : ""}<b>${esc(x.pm)}</b>${off(x) ? `<s>${esc(x.cm)}</s>` : ""}`;
  const saveAmt = x => {
    const cents = /[.,]\d{2}(?!\d)/.test(x.pm);
    const v = ((x.c - x.p) / 100).toLocaleString("en-US", {minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: 2});
    return x.pm.replace(/\d[\d.,]*/, v);
  };
  const badge = x => !x.ok ? '<span class="lg-badge">Sold out</span>' : off(x) ? `<span class="lg-badge">-${off(x)}%</span>` : "";
  function addBtn(x, label){
    if (!x.ok) return `<button class="lg-add" type="button" disabled aria-label="Sold out">${plus}${label ? " Sold out" : ""}</button>`;
    return `<button class="lg-add" type="button" data-v="${esc(x.v)}" data-img="${esc(x.i)}" data-title="${esc(x.t)}" aria-label="Add ${esc(x.t)} to cart">${plus}${label || ""}</button>`;
  }
  function media(x, cls, withAlt){
    return `<a class="${cls}" href="${esc(x.u)}" tabindex="-1" aria-hidden="true">
      ${badge(x)}${withAlt && isUsa(x) ? '<span class="lg-badge lg-usa">Made in USA</span>' : ""}
      ${x.i ? `<img src="${esc(x.i)}" srcset="${esc(x.i.replace("width=600", "width=300"))} 300w, ${esc(x.i.replace("width=600", "width=450"))} 450w, ${esc(x.i)} 600w" sizes="(min-width: 1100px) 300px, (min-width: 750px) 33vw, 50vw" alt="" loading="lazy">` : ""}
      ${withAlt && x.a ? `<img class="lg-alt" src="${esc(x.a)}" alt="" loading="lazy">` : ""}
    </a>`;
  }
  function card(x, n){
    return `<article class="lg-card" style="animation-delay:${(n % 8) * 40}ms">
      ${media(x, "lg-card-media", true)}
      <div class="lg-card-body">
        <span class="lg-card-brand">${esc(brandOf(x.t))}</span>
        <h3><a href="${esc(x.u)}">${esc(x.t)}</a></h3>
        <div class="lg-card-foot"><div class="lg-price">${price(x)}</div>${addBtn(x)}</div>
      </div>
    </article>`;
  }
  function hero(x, label){
    return `<article class="lg-card lg-lamp-hero">
      ${media(x, "lg-card-media", true)}
      <div class="lg-lh-body">
        <span class="lg-card-brand">${esc(brandOf(x.t) || "Flash lamp")} · ${esc(label)}</span>
        <h3><a href="${esc(x.u)}">${esc(x.t)}</a></h3>
        ${x.d ? `<p>${esc(x.d)}</p>` : ""}
        <div class="lg-card-foot"><div class="lg-price">${price(x)}</div>${addBtn(x, " Add to cart")}</div>
      </div>
    </article>`;
  }
  function deal(x){
    return `<article class="lg-deal">
      ${media(x, "lg-deal-img", false)}
      <div class="lg-deal-body">
        <span class="lg-card-brand">${esc(brandOf(x.t))}</span>
        <h3><a href="${esc(x.u)}">${esc(x.t)}</a></h3>
        <div class="lg-deal-foot">
          <div class="lg-price">${price(x)}</div>
          ${off(x) ? `<span class="lg-save">Save ${esc(saveAmt(x))}</span>` : ""}
          ${addBtn(x)}
        </div>
      </div>
    </article>`;
  }

  /* ---------- features ---------- */
  const features = {
    hero(root){
      const box = $(".lg-slider", root);
      if (box) {
        const track = $(".lg-slides", box), slides = [...track.children], dotsEl = $(".lg-dots", box);
        const DUR = (+root.dataset.speed || 6) * 1000; let i = 0, timer = null, paused = false;
        box.style.setProperty("--dur", DUR + "ms");
        $(".lg-s-all", box).textContent = String(slides.length).padStart(2, "0");
        const dots = slides.map((_, n) => {
          const b = document.createElement("button");
          b.type = "button"; b.className = "lg-dot"; b.setAttribute("aria-label", `Go to slide ${n + 1}`); b.innerHTML = "<i></i>";
          b.addEventListener("click", () => go(n)); dotsEl.appendChild(b); return b;
        });
        const go = n => {
          if (!slides.length) return;
          i = (n + slides.length) % slides.length;
          track.style.transform = `translateX(${-100 * i}%)`;
          slides.forEach((s, k) => { s.classList.toggle("lg-is-active", k === i); s.setAttribute("aria-hidden", k !== i); s.tabIndex = k === i ? 0 : -1; });
          dots.forEach((d, k) => { d.classList.remove("lg-run"); d.classList.toggle("lg-done", k < i); });
          void dots[i].offsetWidth; dots[i].classList.add("lg-run");
          $(".lg-s-now", box).textContent = String(i + 1).padStart(2, "0");
          clearTimeout(timer); if (!paused && slides.length > 1) timer = setTimeout(() => go(i + 1), DUR);
        };
        root.lgGo = go;
        $(".lg-prev", box).addEventListener("click", () => go(i - 1));
        $(".lg-next", box).addEventListener("click", () => go(i + 1));
        box.addEventListener("mouseenter", () => { paused = true; box.classList.add("lg-paused"); clearTimeout(timer); });
        box.addEventListener("mouseleave", () => { paused = false; box.classList.remove("lg-paused"); go(i); });
        box.addEventListener("keydown", e => { if (e.key === "ArrowLeft") go(i - 1); if (e.key === "ArrowRight") go(i + 1); });
        let x0 = null, moved = false;
        box.addEventListener("pointerdown", e => { x0 = e.clientX; moved = false; });
        box.addEventListener("pointermove", e => { if (x0 !== null && Math.abs(e.clientX - x0) > 10) moved = true; });
        box.addEventListener("pointerup", e => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1); });
        track.addEventListener("click", e => { if (moved) { e.preventDefault(); moved = false; } }, true);
        track.addEventListener("dragstart", e => e.preventDefault());
        document.addEventListener("visibilitychange", () => { clearTimeout(timer); if (!document.hidden && !paused && slides.length > 1) timer = setTimeout(() => go(i + 1), DUR); });
        go(0);
      }
      // trust strip: a second copy for the phone loop
      const tt = $(".lg-trust-track", root);
      if (tt) [...tt.children].forEach(el => { const c = el.cloneNode(true); c.classList.add("lg-dup"); c.setAttribute("aria-hidden", "true"); tt.appendChild(c); });
    },
    brands(root){
      const track = $(".lg-brands-track", root); if (!track) return;
      [...track.children].forEach(a => { const c = a.cloneNode(true); c.classList.add("lg-dup"); c.setAttribute("aria-hidden", "true"); c.tabIndex = -1; track.appendChild(c); });
    },
    products(root){
      const list = data(root), layout = root.dataset.layout;
      if (!list.length) { if (!window.Shopify || !Shopify.designMode) root.hidden = true; return; }
      const box = $("[data-list]", root);
      if (layout === "lamps") {
        $('[data-list="hero"]', root).innerHTML = hero(list[0], root.dataset.heroLabel || "Top seller");
        $('[data-list="rest"]', root).innerHTML = list.slice(1, 7).map(card).join("");
      } else if (layout === "deals") box.innerHTML = list.map(deal).join("");
      else box.innerHTML = list.map(card).join("");
    },
    featured(root){
      const grid = $(".lg-fgrid", root), filters = $(".lg-filters", root), more = $(".lg-more", root);
      const PAGE = +root.dataset.page || 8, items = data(root), all = root.dataset.allLabel || "All";
      const types = [...new Set(items.map(x => x.type).filter(Boolean))];
      let type = all, shown = PAGE;
      if (types.length < 2 || root.dataset.filters === "false") filters.hidden = true;
      filters.innerHTML = [all, ...types].map(t => `<button class="lg-chip" type="button" aria-pressed="${t === all}" data-type="${esc(t)}">${esc(t)}</button>`).join("");
      const render = () => {
        const list = items.filter(x => type === all || x.type === type);
        grid.innerHTML = list.slice(0, shown).map(card).join("");
        const left = list.length - shown;
        more.hidden = left <= 0;
        $("span", more).textContent = (root.dataset.moreLabel || "Show [n] more").replace("[n]", Math.min(left, PAGE));
      };
      filters.addEventListener("click", e => {
        const b = e.target.closest(".lg-chip"); if (!b) return;
        type = b.dataset.type; shown = PAGE;
        $$(".lg-chip", filters).forEach(c => c.setAttribute("aria-pressed", c === b));
        render();
      });
      more.addEventListener("click", () => { shown += PAGE; render(); });
      render();
    },
    highlights(root){
      const box = $(".lg-reviews", root); if (!box) return;
      const track = $(".lg-r-track", box), items = [...track.children], dotsEl = $(".lg-r-dots", box);
      if (!items.length) return;
      let i = 0, t;
      const dots = items.map((_, n) => { const b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", `Slide ${n + 1}`); b.onclick = () => go(n); dotsEl.appendChild(b); return b; });
      const go = n => {
        i = (n + items.length) % items.length;
        track.style.transform = `translateX(${-100 * i}%)`;
        dots.forEach((d, k) => d.setAttribute("aria-current", k === i));
        clearTimeout(t); if (items.length > 1) t = setTimeout(() => go(i + 1), 7000);
      };
      root.lgGo = go;
      $('[data-r="prev"]', box).onclick = () => go(i - 1);
      $('[data-r="next"]', box).onclick = () => go(i + 1);
      go(0);
    },
  };

  function init(root){
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    const f = features[root.dataset.lgcc];
    if (f) f(root);
  }
  const initAll = scope => $$(".lgcc-h[data-lgcc]", scope || document).forEach(init);

  /* ---------- toast + add to cart (shared) ---------- */
  let toast, toastTimer;
  function showToast(img, text, ok){
    if (window.LGCC && LGCC.toast) return LGCC.toast(img, text, ok);   // Laser GCC footer present
    if (!toast) {
      const w = document.createElement("div"); w.className = "lgcc-h";
      w.innerHTML = `<div class="lg-toast" role="status" aria-live="polite"><img alt=""><span></span><a class="lg-toast-link" href="${ROUTE}cart">View cart</a></div>`;
      document.body.appendChild(w); toast = $(".lg-toast", w);
    }
    const im = $("img", toast); im.hidden = !img; if (img) im.src = img;
    $("span", toast).textContent = text; $(".lg-toast-link", toast).hidden = !ok;
    toast.classList.toggle("lg-error", !ok); toast.classList.add("lg-show");
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove("lg-show"), 3200);
  }
  async function refreshCart(){
    try {
      const cart = await (await fetch(ROUTE + "cart.js", {headers: {Accept: "application/json"}})).json();
      document.querySelectorAll("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; });
      const bubble = document.getElementById("cart-icon-bubble"); if (!bubble) return;
      const res = await (await fetch(ROUTE + "?sections=cart-icon-bubble")).json();
      if (!res["cart-icon-bubble"]) return;
      const doc = new DOMParser().parseFromString(res["cart-icon-bubble"], "text/html");
      const inner = doc.querySelector(".shopify-section");
      bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
    } catch (e) {}
  }
  document.addEventListener("click", async e => {
    const b = e.target.closest(".lgcc-h .lg-add");
    if (!b || b.disabled || !b.dataset.v) return;
    const label = b.innerHTML; b.disabled = true;
    try {
      const r = await fetch(ROUTE + "cart/add.js", {
        method: "POST", headers: {"Content-Type": "application/json", Accept: "application/json"},
        body: JSON.stringify({items: [{id: Number(b.dataset.v), quantity: 1}]})
      });
      if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || "This item couldn't be added. Open the product page to choose options."); }
      b.classList.add("lg-done"); b.innerHTML = check;
      showToast(b.dataset.img, "Added: " + b.dataset.title, true);
      refreshCart(); document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (err) { showToast("", err.message, false); }
    finally { setTimeout(() => { b.classList.remove("lg-done"); b.innerHTML = label; b.disabled = false; }, 1400); }
  });

  /* ---------- theme editor: re-run a section after it is edited; jump to a selected slide ---------- */
  document.addEventListener("shopify:section:load", e => initAll(e.target));
  document.addEventListener("shopify:block:select", e => {
    const root = e.target.closest(".lgcc-h");
    const slide = e.target.closest("[data-index]");
    if (root && root.lgGo && slide) root.lgGo(+slide.dataset.index);
  });

  window.LGCC_HOME = { initAll };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll()); else initAll();
})();
